import { useDispatch, useSelector } from 'react-redux';
import FJAction from '../../action/FJAction';
import ResetPasswordBrick from './ResetPasswordBrick';

const ResetPasswordContainer = props => {
    let { popupType, stepChange } = props;
    const dispatch = useDispatch();
    const { confirmEmail, code } = useSelector(store => {
        return {
            email: store.mainStore.confirmEmail,
            code: store.mainStore.registerCode,
        };
    });
    // 重置密码
    let _resetPassword = (password, confirm, callback) => {
        dispatch(FJAction.resetPassword({ newPassword: password, confirmPassword: confirm, code }, callback));
    };

    return (
        <ResetPasswordBrick
            email={confirmEmail}
            stepChange={stepChange}
            resetClick={_resetPassword}
            popupType={popupType}
            active={true}
        />
    );
};
export default ResetPasswordContainer;
